import React, { FC, useCallback, useEffect } from 'react';

import PropTypes from 'prop-types';

import { TOOL_IDS, ToolIdType } from '@adsk/alloy-provider';
import {
  RemoteComponent,
  type RemoteComponentProps,
} from '@adsk/exo-skeleton-react';

import {
  removeCurrentToolScopeFromContext,
  setCurrentToolScopeToContext,
} from '../../utils/monitoring';
import ToolContentError from '../AppContentError/ToolContentError';
import { ContentLayoutLoader } from '../FullPageLayoutLoader/ContentLayoutLoader';

export type RemoteToolProps = Pick<
  RemoteComponentProps,
  'scope' | 'moduleName'
> & {
  toolId?: ToolIdType | 'demo-app' | '';
};

const renderLoader = () => <ContentLayoutLoader />;

const RemoteTool: FC<RemoteToolProps> = ({ toolId, moduleName, scope }) => {
  useEffect(() => {
    setCurrentToolScopeToContext(scope);

    return () => {
      removeCurrentToolScopeFromContext();
    };
  }, [scope]);

  const renderError = useCallback(
    () => <ToolContentError key={toolId} />,
    [toolId],
  );

  return (
    <RemoteComponent
      moduleName={moduleName}
      scope={scope}
      renderError={renderError}
      renderLoader={renderLoader}
    />
  );
};

RemoteTool.propTypes = {
  moduleName: PropTypes.string.isRequired,
  scope: PropTypes.string.isRequired,
  toolId: PropTypes.oneOf([...Object.values(TOOL_IDS), 'demo-app', '']),
};

export default RemoteTool;
